import { render, staticRenderFns } from "./ButtonPill.vue?vue&type=template&id=002def67&"
import script from "./ButtonPill.vue?vue&type=script&lang=js&"
export * from "./ButtonPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports